module.exports = __webpack_public_path__ + "media/images/icons/circle-94fa3daca6f7b16db8b2c46e3d3af30e.svg";